import {
  CAMERA_MOVEMENT_CREDIT_CHECK,
  CAMERA_ZOOM_CREDIT_CHECK,
  CAPTURE_CLIP_CREDIT_CHECK,
  CAPTURE_PHOTO_CREDIT_CHECK,
} from './types';

const initialState = { show: false, message: '' };

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case CAMERA_MOVEMENT_CREDIT_CHECK:
    case CAMERA_ZOOM_CREDIT_CHECK:
    case CAPTURE_CLIP_CREDIT_CHECK:
    case CAPTURE_PHOTO_CREDIT_CHECK:
      return { ...state, ...payload };
    default:
      return state;
  }
};
